<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>
          <strong>Создать онбординг</strong>
        </CCardHeader>
        <CCardBody>
          <OnboardingForm :onboarding="onboarding" @save="createOnboarding" />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { CRow, CCol, CCard, CCardHeader, CCardBody } from '@coreui/vue';
import OnboardingForm from '@/components/onboarding/OnboardingForm';

export default {
  components: {
    CRow,
    CCol,
    CCard,
    CCardHeader,
    CCardBody,
    OnboardingForm,
  },
  data() {
    return {
      onboarding: {
        title: '',
        enabled: true,
        parent_promocode_id: null,
      },
    };
  },
  methods: {
    async createOnboarding(onboarding) {
      try {
        await this.axios.post('/onboarding', onboarding);
        this.$router.push('/onboarding');
      } catch (error) {
        this.$root.$emit('showError', error?.response?.data?.message || 'Ошибка создания онбординга.');
      }
    },
  },
};
</script>
